<fieldset>
	<legend class="mb-3">Fizetési módok</legend>

	<div class="card text-dim mb-1 p-1" style="background-color:rgba(0,0,0,0.2);">
		<div class="row">
			<div class="col">
				Megnevezés
			</div>
			<div class="col-auto text-center" style="width:120px; margin-top:-2px; margin-bottom:-2px;">
				<small>
					⬐&nbsp;Adóögyi&nbsp;⬎<br />
					<span class="float-start">FreePOS</span>
					<span class="float-end">Fiscat</span>
				</small>
			</div>
			<div class="col-auto text-center" style="width:120px; margin-top:-2px; margin-bottom:-2px;">
				<small>
					⬐&nbsp;&nbsp;&nbsp;QR&nbsp;&nbsp;&nbsp;⬎<br />
					<span class="float-start">Sam4s</span>
					<span class="float-end">Fiscat</span>
				</small>
			</div>
			<div class="col-auto text-center" style="width:100px; margin-top:-2px; margin-bottom:-2px;">
				<small>
					Engedélyezett<br />
					PG fizetésnél
				</small>
			</div>
		</div>
	</div>
	<% for (const payment_method of payment_methods) { %>
	<div class="card <% if (payment_method.ntak_type == 'KESZPENZHUF' || payment_method.ntak_type == 'KESZPENZEUR' || payment_method.ntak_type == 'BANKKARTYA') { %>text-light<% } else { %>text-dim<% } %> mb-1 p-1">
		<div class="row">
			<div class="col">
				<%= payment_method.name_hu %>
			</div>
			<div class="col-auto text-center" style="width:60px;">
				<small><%- payment_method.freepos_code || '<span class="text-dim">-</span>' %></small>
			</div>
			<div class="col-auto text-center" style="width:60px;">
				<small><%- payment_method.fiscat_code || '<span class="text-dim">-</span>' %></small>
			</div>
			<div class="col-auto text-center" style="width:60px;">
				<small><%- payment_method.sam4s_qr_code || '<span class="text-dim">-</span>' %></small>
			</div>
			<div class="col-auto text-center" style="width:60px;">
				<small><%- payment_method.fiscat_qr_code || '<span class="text-dim">-</span>' %></small>
			</div>
			<div class="col-auto text-center" style="width:97px;">
			<% if (payment_method.enabled_for_ecr) { %>
				<div class="badge bg-success text-light">Igen</div>
			<% } else { %>
				<% if (payment_method.ntak_type == 'KESZPENZHUF' || payment_method.ntak_type == 'KESZPENZEUR' || payment_method.ntak_type == 'BANKKARTYA') { %>
					<div class="badge bg-warning text-light">Nem</div>
				<% } else { %>
					<div class="badge bg-dark text-dim">Nem</div>
				<% } %>
			<% } %>
			</div>
		</div>
	</div>
	<% } %>
</fieldset>